import React, { useEffect, useState } from 'react';
import { Popover, Button, Modal, message } from 'antd';
import { restApi } from '../../../apis';

function TitleComponent(props) {
  return (
    <div
      style={{
        display: 'flex',
        height: '4.2rem',
        justifyContetn: 'center',
        alignItems: 'center',
        background: '#7367F0',
        borderRadius: '10px 10px 0px 0px',
        paddingLeft: 20,
        color: '#FFF',
      }}
    >{`운동별 메뉴`}</div>
  );
}
//----------------------------------------------------------------------------------------------------
function ContentComponent(props) {
  const {
    gModal,
    setGModal,
    uuid,
    big,
    mid,
    sml,
    eng_name,
    kor_name,
    setPopup,
    isPublic,
    messageApi,
    onRefresh,
  } = props;
  const [modal, setModal] = useState({
    open: false,
    type: 1,
    message: '',
    btnTitle: '',
  });

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        // alignItems: 'center',
        // justifyContent: 'center',
      }}
    >
      {/*----------------------------------------------------------------------------------------------------  */}
      <div
        style={{
          display: 'flex',
          marginTop: '-0.7rem',
          padding: '0rem 0rem 0rem 0rem',
          borderBottom: '1px solid #DBDADE',
        }}
      >
        <Button
          style={{
            display: 'flex',
            width: '100%',
            height: '5.4rem',
            alignItems: 'center',
          }}
          type="text"
          shape="default"
          size="middle"
          onClick={(e) => {
            // Route.Link('/');
            setModal((prev) => {
              const isNowPublic = isPublic == 'F';
              return {
                type: 1,
                open: true,
                message: isNowPublic
                  ? `정말 [${big + '>' + mid + '>' + sml}] 내 [${kor_name}] 운동을 공개로 전환하시겠습니까? 공개시 밸런스피터 앱에서 보이게 됩니다.`
                  : `정말 [${big + '>' + mid + '>' + sml}] 내 [${kor_name}] 운동의 공개여부를 비공개로 전환하시겠습니까? 비공개시 밸런스피터 앱에서 보이지 않게 됩니다.`,
                btnTitle: isNowPublic ? '공개' : '비공개',
              };
            });
            setPopup(false);
          }}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              fontFamily: 'Public Sans',
              fontStyle: 'normal',
              fontWeight: 400,
              fontSize: '1.5rem',
              lineHeight: '2.2rem',
            }}
          >
            {`${isPublic == 'F' ? '공개' : '비공개'} 전환`}
          </div>
        </Button>
      </div>
      {/*----------------------------------------------------------------------------------------------------  */}
      <div
        style={{
          display: 'flex',
          padding: '0rem 0rem 0rem 0rem',
          borderBottom: '1px solid #DBDADE',
        }}
      >
        <Button
          style={{
            display: 'flex',
            width: '100%',
            height: '5.4rem',
            alignItems: 'center',
          }}
          type="text"
          shape="default"
          size="middle"
          onClick={(e) => {
            setModal((prev) => {
              return {
                type: 2,
                open: true,
                message: `삭제한 운동 데이터는 다시 복구할 수 없습니다.\n정말 [${
                  big + '>' + mid
                }] 내 [${sml}] > [${kor_name}] 운동을 삭제하시겠습니까?`,
                btnTitle: '삭제',
              };
            });
            setPopup(false);
          }}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              fontFamily: 'Public Sans',
              fontStyle: 'normal',
              fontWeight: 400,
              fontSize: '1.5rem',
              lineHeight: '2.2rem',
              color: '#DB4437',
            }}
          >
            {`운동 삭제하기`}
          </div>
        </Button>
      </div>
      {/*----------------------------------------------------------------------------------------------------  */}
      <Modal
        title={
          <div
          // style={{
          //   background: 'rgba(168, 170, 174, 0.16)',
          // }}
          >
            알림
          </div>
        }
        open={modal.open}
        centered
        closable={false} // Whether a close (x) button is visible on top right of the modal dialog or not
        footer={[
          <Button
            key="delete"
            type="primary"
            // loading={loading}
            onClick={(e) => {
              if (modal.type == 1) {
                // 활성 / 비 활성
                (async () => {
                  const publicValue =
                    isPublic == 'F' ? 'T' : isPublic == 'T' ? 'F' : 'T';
                  await restApi
                    .patch(
                      `/admin/exercise/${uuid}?isPublic=${publicValue}`,
                      {}
                    )
                    .then((res) => {
                      messageApi &&
                        messageApi.info(
                          `운동 공개 상태를 ${
                            publicValue == 'F' ? '비공개' : '공개'
                          }하였습니다.`
                        );
                      return res;
                    })
                    .catch((e) => {
                      messageApi &&
                        messageApi.error(
                          `[Error] ${e || '운동 상태변경에 실패하였습니다.'}`
                        );
                    });

                  onRefresh && onRefresh();
                })();
              } else {
                // 삭제

                (async () => {
                  await restApi
                    .delete(`/admin/exercise/${uuid}`, {})
                    .then((res) => {
                      messageApi &&
                        messageApi.info(`운동 정보를 삭제 하였습니다.`);
                      return res;
                    })
                    .catch((e) => {
                      messageApi &&
                        messageApi.error(
                          `[Error] ${e || '운동 정보 삭제에 실패하였습니다.'}`
                        );
                    });

                  onRefresh && onRefresh();
                })();
              }
              setModal((prev) => {
                return { ...prev, open: false };
              });
            }}
            danger
          >
            {modal.btnTitle}
          </Button>,
          <Button
            key="cancel"
            type="default"
            onClick={(e) => {
              setModal((prev) => {
                return { ...prev, open: false };
              });
            }}
          >
            {`취소`}
          </Button>,
        ]}
      >
        <p>{modal.message}</p>
      </Modal>
      {/*----------------------------------------------------------------------------------------------------  */}
    </div>
  );
}
//----------------------------------------------------------------------------------------------------

const ExercisePopover = (props) => {
  const { component, width } = props;
  const [clicked, setPopup] = useState(false);

  return (
    <Popover
      placement="leftTop"
      title={TitleComponent({ ...props })}
      content={<ContentComponent {...props} setPopup={setPopup} />}
      overlayStyle={{ width: 240 }}
      overlayInnerStyle={{ padding: 0 }}
      showArrow={false}
      trigger="click" // focus  hover  click
      open={clicked}
      onOpenChange={(open) => {
        setPopup(open);
      }}
    >
      <Button
        type="link"
        style={{
          display: 'flex',
          width,
          flexDirection: 'column',
          justifyContetn: 'center',
          alignItems: 'center',
        }}
      >
        {component}
      </Button>
    </Popover>
  );
};

export default ExercisePopover;
